import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Container = styled(Box)<{ isactive?: string }>`
  display: flex;
  padding: ${theme.spacing.md}px ${theme.spacing.medium}px;
  justify-content: space-between;
  align-items: center;
  border-radius: ${theme.attributes.borderRadius.quaternary};
  min-height: 72px;
  background: ${theme.colors.frameworkCardBg};

  &:hover {
    background: ${theme.colors.btnTertiaryBg};
  }

  html[data-theme='light'] &:hover {
    background: ${theme.colors.menuItemHover};
  }

  /* CpiChip and CpiActiveButton are shared and carry a shadow that reads heavy on light surfaces. */
  html[data-theme='light'] & {
    .left > .MuiBox-root {
      box-shadow: none;
    }
  }

  .left,
  .right {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.small}px;
    max-width: ${({ isactive }) => (isactive && isactive === 'true' ? 'calc(100% - 156px)' : 'unset')};
  }

  .title {
    color: ${theme.colors.foreground};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: normal;
    max-width: 55%;
  }

  .MuiOutlinedInput-root {
    border-radius: ${theme.attributes.borderRadius.small};
    border: 1px solid ${theme.colors.controlBorder};
    letter-spacing: 0.5px;
    height: 48px;
    color: ${theme.colors.foreground};
    text-align: center;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: normal;

    input {
      padding-left: 22px;
    }

    &:hover {
      border-color: ${theme.colors.menuItemText};
    }

    &.Mui-focused {
      border: 1px solid ${theme.colors.cta} !important;
    }

    fieldset {
      border: 0;
    }
  }

  .percentage {
    .MuiTypography-root {
      color: ${theme.colors.foreground};
      text-align: center;
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: normal;
    }
  }

  .MuiFormControl-root {
    width: 81px;
  }

  .length3 input {
    padding-left: ${theme.spacing.small}px;
  }

  .length1 input {
    padding-left: ${theme.spacing.large}px;
  }

  .Mui-disabled {
    color: ${theme.colors.devicesSecondaryText};
    -webkit-text-fill-color: ${theme.colors.devicesSecondaryText};
    cursor: not-allowed;
  }

  .Mui-focused {
    border: 1px solid ${theme.colors.cta};

    input {
      width: 100%;
    }
  }

  .close-button {
    color: ${theme.colors.cta};

    &:hover {
      background: ${theme.colors.surfaceItemBackgroundLow};
    }
  }

  .no-role-weights-wrapper {
    padding-right: ${theme.spacing.medium}px;
  }
`
